import { LcaResultModel } from 'types/types';
import LcaResultsGrid from './LcaResultsGrid';
import LcaResultsGridPdf from './LcaResultsGridPdf';
import {
  createVariationColumnWithDisclaimer,
  LcaResultsGridColumnsNoCategory,
  LcaResultsGridColumnsNoCategoryPdf,
} from './LcaResultsGridColumns';
import { LcaGridNote } from '../GridService';
import useLcaGridHelper from '../../hooks/useLcaGridHelper';

type TProps = {
  epdVersionId: string;
  rows: LcaResultModel[] | undefined;
  isForPdf?: boolean;
  disabled?: boolean;
  preferEnabledAppearanceEvenWhenDisabled?: boolean;
  className?: string;
};

const LcaResultsGridOutputFlowConstruction = ({
  epdVersionId,
  rows,
  isForPdf,
  disabled,
  preferEnabledAppearanceEvenWhenDisabled,
  className,
}: TProps) => {
  const { generalDisclaimerNote, showVariationColumn, createVariationDisclaimerNote } = useLcaGridHelper(epdVersionId);

  const notes: LcaGridNote[] = [
    {
      note: 'Acronyms',
      description:
        'CRU = Components for re-use; MFR = Materials for recycling; MER = Materials for energy recovery; EEE = Exported electrical energy; EET = Exported thermal energy.',
    },
  ];

  if (generalDisclaimerNote) {
    notes.push(generalDisclaimerNote);
  }

  let columns = isForPdf ? LcaResultsGridColumnsNoCategoryPdf : LcaResultsGridColumnsNoCategory;
  if (showVariationColumn && (!isForPdf || (isForPdf && rows?.some((r) => r.variation)))) {
    const disclaimerNumber = 1;
    columns = [...columns, createVariationColumnWithDisclaimer(disclaimerNumber)];
    notes.push(createVariationDisclaimerNote(disclaimerNumber));
  }

  if (isForPdf) {
    return <LcaResultsGridPdf rows={rows} columns={columns} notes={notes} />;
  }
  return (
    <LcaResultsGrid
      className={className}
      epdVersionId={epdVersionId}
      value={rows}
      columns={columns}
      notes={notes}
      disabled={disabled}
      preferEnabledAppearanceEvenWhenDisabled={preferEnabledAppearanceEvenWhenDisabled}
    />
  );
};

export default LcaResultsGridOutputFlowConstruction;
